import React from 'react'
import FooterMenu from '../../component/layout/FooterMenu'
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

function TraininGuidelines() {
    const {t} = useTranslation();
    const openUrl = (url) =>{
        window.open(url, '_system')
    }
  return (
    <>
    <FooterMenu></FooterMenu>
    <div className="main-container">
      <p class="alertformheading">Training</p>
      <p>Non-Communicable Diseases, are a group of medical conditions that are primarily caused by lifestyle and environmental factors, rather than infectious agents. These diseases, including heart disease, diabetes, cancer, and respiratory disorders, have become a significant global health challenge. To address this issue, the World Health Organization (WHO) has published comprehensive guidelines and recommendations to help countries and healthcare systems effectively manage and prevent NCDs.</p>

      <p>Below are the guidelines published by WHO under various headings. You can click on any link to access the full file:    </p>
      {/* <ul className='guideline-links'>
            <Tooltip title={t("Font Resize")} arrow placement="right">
                <li onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guidelines-for-primary-health-care.pdf')}>
                    Guidelines for primary health care in low-resource settings
                </li>
            </Tooltip>
            <li onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guideline-for-the-pharmacological-treatment-of-hypertension.pdf')}>
                Guideline for the pharmacological treatment of hypertension in adults
            </li>
            <li onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/comprehensive-cervical-cancer-control.pdf')}>
                Comprehensive cervical cancer control
             </li>
            <li onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guideline-on-self-care-interventions-for-health.pdf')}>
                WHO guideline on self-care interventions for health and well-being, 2022 revision
            </li>
      </ul> */}

      <List className='guideline-links'>
            <ListItem disablePadding onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guidelines-for-primary-health-care.pdf')}>
                <ListItemIcon>
                    <NavigateNextIcon />
                </ListItemIcon>
                <ListItemText primary={t("Guidelines for primary health care in low-resource settings")} />
            </ListItem>
            <ListItem disablePadding onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guideline-for-the-pharmacological-treatment-of-hypertension.pdf')}>
                <ListItemIcon>
                    <NavigateNextIcon />
                </ListItemIcon>
                <ListItemText primary={t("Guideline for the pharmacological treatment of hypertension in adults")} />
            </ListItem>
            <ListItem disablePadding onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/comprehensive-cervical-cancer-control.pdf')}>
                <ListItemIcon>
                    <NavigateNextIcon />
                </ListItemIcon>
                <ListItemText primary={t("Comprehensive cervical cancer control")} />
            </ListItem>
            <ListItem disablePadding onClick={()=>openUrl('https://ncderegistry.imonitorplus.com/training/guideline-on-self-care-interventions-for-health.pdf')}>
                <ListItemIcon>
                    <NavigateNextIcon />
                </ListItemIcon>
                <ListItemText primary={t("WHO guideline on self-care interventions for health and well-being, 2022 revision")} />
            </ListItem>
    </List>
    </div>
    </>
  )
}

export default TraininGuidelines
